import logo from '../Assets/Imgs/Dark-Z-Logo-Square.png';
import logoNoBg from '../Assets/Imgs/logos/Zeroz-Logo-Horizontal-Black.png';
import headerStory from '../Assets/Imgs/Header-Images-Story.jpg';
import profileZ from '../Assets/Imgs/Profile-Shot-Ally.png';
import profileAtlas from '../Assets/Imgs/Profile-Shot-Altlas.png';
import profileMonsterEGirl from '../Assets/Imgs/Profile-Shot-MonsterEGirl.png';
import profileAthlough from '../Assets/Imgs/Profile-Shot-Athlough.png';
import profileAtrius from '../Assets/Imgs/Profile-Shot-Atrius.png';
import profileAdmiral from '../Assets/Imgs/Profile-Shot-Admiral.png';

import NavBar from '../Components/NavBar';
import Footer from '../Components/Footer';
import SongCard from '../Components/SongCard';

function Story() {
  return (
    <div className="App">
      <NavBar />
      
      <div className="header-Banner">
        <img src={headerStory} className="header-img" alt="header" />
        <h2 className="header-subtext">Zeroz is the story of an amnesiac musician that wakes up in a white room</h2>
      </div>

      <header className="app-row">
        <div className="card full black backgroundWhite">
          <h2>The Story So Far...</h2>
          <p className="textBlock">Zeroz follows Z the amnesiac. Z wakes up trapped in a white room with no memories. <br /> 
          From there, Z makes friends with members from the mysterious Sied organization.<br />
          Z finds this new world of friendhsip, fighting and broken memories.</p>
        </div>
      </header>
      
      <h1 className="black titleSpacer">Main Characters</h1>
      
      <div className="page-section row space-evenly">
        <div className="card-story-character">
          <img src={profileZ} className="card-image-background" alt="profileZ" />
          <div className='charachter-bio-diagonal'>
            <div className="insetBorder" />
            <h4>Name: ???/Z</h4>
            <p>Age: ???</p>
            <p>Rank: ???</p>
            <p>Skills: Crying, making art, guiar, bass, vocals keys, production</p>
            <p>Description: ??? woke up in a white room with no memories of their past. They have fought  and cried for any kind of meaning or memories.</p>
          </div>
        </div>

        <div className="card-story-character">
          <img src={profileAtlas} className="card-image-background" alt="profileAtlas" />
          <div className='charachter-bio-diagonal'>
            <div className="insetBorder" />
            <h4>Name: Atlas Helicopter</h4>
            <p>Age: 500</p>
            <p>Rank: Navigation Re-Controller</p>
            <p>Skills: Inter-Dimensional Navigation, Drumming, kicking buns</p>
            <p>Description: Atlas Helicopter is a crucial member of the Butterfly Unit of Sied</p>
          </div>
        </div>

      </div>

      <div className="card full black backgroundWhite app-row">
        <h2 className="black titleSpacer">Supporting Characters</h2>
        <p className="textBlock">
          The Zeroz story is full of characters helping Z find his true identity--from mysterious leaders to dead ass bad guys. Everyone is important in the story of Zeroz.
        </p>
      </div>

      <div className="page-section row space-evenly">
        <div className="card-story-character">
          <img src={profileMonsterEGirl} className="card-image-background" alt="profileZ" />
          <div className='charachter-bio-diagonal'>
            <div className="insetBorder" />
            <h4>Name: Monster E Girl</h4>
            <p>Age: ???</p>
            <p>Rank: Deadly</p>
            <p>Skills: Kicking ass, dancing, inter-dimensional transportation</p>
            <p>Description: Discovered Atalas and Z in the white room and beat the ever living crap out of them.</p>
          </div>
        </div>

        <div className="card-story-character">
          <img src={profileAtrius} className="card-image-background" alt="profileAtlas" />
          <div className='charachter-bio-diagonal'>
            <div className="insetBorder" />
            <h4>Name: Atrius Sied</h4>
            <p>Age: 50,000</p>
            <p>Rank: Commander of Sied</p>
            <p>Skills: Temporal modulation, spacial rerendering, advanced combat and many unknonw skills.</p>
            <p>Atrius commands the mysterious Sied organization. His goals are unknown but he seems to know something about Z's past.</p>
          </div>
        </div>
      </div>

      <div className="page-section row space-evenly">
        <div className="card-story-character">
          <img src={profileAdmiral} className="card-image-background" alt="profileZ" />
          <div className='charachter-bio-diagonal'>
            <div className="insetBorder" />
            <h4>Name: Admiral Hoargwartz</h4>
            <p>Age: 6 million</p>
            <p>Rank: Not an actual Admiral, just his name</p>
            <p>Skills: Advanced technical knowledge, sonic pattern recognition, and legs of steel.</p>
            <p>Description: Admiral is a member of Sied and has helped Atlas and Z on various missions.</p>
          </div>
        </div>

        <div className="card-story-character">
          <img src={profileAthlough} className="card-image-background" alt="profileAtlas" />
          <div className='charachter-bio-diagonal'>
            <div className="insetBorder" />
            <h4>Name: Athlough Hell</h4>
            <p>Age: Deceased</p>
            <p>Rank: Inter-Dimensional Data Analyst</p>
            <p>Skills: Inter-Dimensional Telemetry</p>
            <p>Description: Athlough was a member of the Butterfly Unit of Sied. He discovered Z and helped him escape danger.</p>
          </div>
        </div>
      </div>

      <div className="card full black backgroundWhite app-row">
        <h2 className="black titleSpacer">Locations</h2>
        <p className="textBlock">
          The Zeroz story takes place in strange inter-dimensional spaces. From Z waking up in the White Room to bouncing around the Sied spaceship, and hidden spaces inbetween.
        </p>
      </div>

      <div className="page-section row space-evenly">
        <div className="card-story-character">
          <img src={profileMonsterEGirl} className="card-image-background" alt="profileZ" />
          <div className='charachter-bio-diagonal'>
            <div className="insetBorder" />
            <h4>Location: The White Room</h4>
            <p>Size: ???</p>
            <p>Features: Endless, Always white, contains a floating screen.</p>
            <p>Description: Atlas awakes here after being blessed by a falling Black Star.</p>
          </div>
        </div>

        <div className="card-story-character">
          <img src={profileAtrius} className="card-image-background" alt="profileAtlas" />
          <div className='charachter-bio-diagonal'>
            <div className="insetBorder" />
            <h4>Location: Sied Ship</h4>
            <p>Size: 50,000 ft x 30,000 ft x 25,000 ft</p>
            <p>Features: Full Sied Crew, Inter-Dimensional-Space-Drive, Free Hot Chocolate.</p>
            <p>Description: A mobile fortress that allows the members of Sied to carry out their inter-dimensional mission.</p>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Story;
